import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const fetchDebtorReceiptRecord = createAsyncThunk(
  "debtorReceiptRecord/fetch",
  async (
    { selectedFilterType, selectedRecordType, filters },
    { rejectWithValue }
  ) => {
    try {
      let url = "/dashboard/get-debitor-rcv-record";

      if (selectedRecordType === "with details") {
        url = "/accounts/get-debitor-rcv-with-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        locationId:
          selectedFilterType === "By Location"
            ? filters.locationId || null
            : null,
        customerId:
          selectedFilterType === "By Customer"
            ? filters.customerId || null
            : null,
        userId:
          selectedFilterType === "By User" ? filters.userId || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);

      // Map the response data to match table structure
      let mapped = [];
      if (selectedRecordType === "with details") {
        mapped = res.data.map((row, idx) => ({
          id: row.rcv_id,
          rcv_code: row.rcv_code,
          created_date: row.created_date,
          acc_code: row.acc_code,
          acc_name: row.acc_name,
          contact_no: row.contact_no,
          address: row.address,
          full_name: row.full_name,
          details: row.details,
        }));
      } else {
        mapped = res.data.map((row) => ({
          id: row.rcv_id,
          rcv_code: row.rcv_code,
          created_date: row.created_date,
          acc_code: row.acc_code,
          acc_name: row.acc_name,
          contact_no: row.contact_no,
          address: row.address,
          full_name: row.full_name,
          rcv_total: Number(row.rcv_total || 0).toFixed(2),
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
